import React, { createContext, useContext, useState, useEffect } from "react";

interface CommandMenuContextType {
    open: boolean;
    setOpen: (open: boolean) => void;
    toggle: () => void;
}

const CommandMenuContext = createContext<CommandMenuContextType | undefined>(undefined);

export const CommandMenuProvider = ({ children }: { children: React.ReactNode }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const down = (e: KeyboardEvent) => {
            if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                setOpen((open) => !open);
            }
        };

        document.addEventListener("keydown", down);
        return () => document.removeEventListener("keydown", down);
    }, []);

    const toggle = () => setOpen((prev) => !prev);

    return (
        <CommandMenuContext.Provider value={{ open, setOpen, toggle }}>
            {children}
        </CommandMenuContext.Provider>
    );
};

export const useCommandMenu = () => {
    const context = useContext(CommandMenuContext);
    if (!context) {
        throw new Error("useCommandMenu must be used within a CommandMenuProvider");
    }
    return context;
};
